<template>
	<nav>
		<VTabsV2
			:tabs="tabs"
			:base-url="ContractsPublicService.baseUrl"
		/>
	</nav>

	<VDataGridV2
    layout="fill"
    id="contracts-public-registry"
		entity-type="contractPublic"
		:data="contracts"
		@row:dblclick="row => onContractWatch(row)"
	>
		<VDataGridColumnV2
			id="publicationDate"
			label="Опубликовано"
      content-align="center"
			width="120px"
		>
			<template #default="{ row }">
				<template v-if="row.isDraft">
					Черновик
				</template>
				<template v-else>
					{{ $core.utils.date.format(row.publicationDate, 'DD|MM|yyyy') }}
				</template>

				<div>
					<VBadge
						v-if="row.isActual"
						class="primary"
					>
						Актуальная версия
					</VBadge>
					<VBadge
						v-if="row.publicationDate > today"
						class="warning"
					>
						Не вступил в силу
					</VBadge>
				</div>
			</template>
		</VDataGridColumnV2>

		<VDataGridColumnV2
			id="createdAt"
			label="Обновлено"
		>
			<template #default="{ row }">
				<div
					v-if="row.updatedAt instanceof Date"
					class="edit-time-info"
				>
					Обновлено <span>{{ $core.utils.date.humanizeDate(row.updatedAt) }}</span>.
				</div>
				<div
					v-else
					class="edit-time-info"
				>
					Создано <span>{{ $core.utils.date.humanizeDate(row.createdAt) }}</span>.
					<div class="description">
						{{ row.createdBy && row.createdBy.name ? row.createdBy.name : '' }}
					</div>
				</div>
			</template>
		</VDataGridColumnV2>

		<VDataGridColumnV2
			id="actions"
			vertical-align="middle"
			width="95px"
		>
			<template #default="{ row }">
				<div class="contract-actions-wrap">
					<VButton
						title="Скачать в pdf"
						@click="ContractsPublicService.getPdf(row.type, row.version)"
            material="picture_as_pdf"
          />

					<VButton
						v-if="row.isDraft"
						title="Редактировать"
						theme="primary"
						@click="onContractWatch(row)"
            material="edit"
					/>

					<VButton
						v-if="!row.isDraft"
						title="Посмотреть"
						@click="onContractWatch(row)"
            material="visibility"
					/>
				</div>
			</template>
		</VDataGridColumnV2>
	</VDataGridV2>
</template>

<style lang="scss" src="./ContractsPublicPage.scss"></style>

<script lang="ts">

import ContractsPublicService from '@/domains/Contracts/ContractsPublicService';
import ContractPublic         from '@/domains/Contracts/ContractPublic';

export default defineComponent({
	name: 'ContractsPublicPage',

	data() {
		return {
			ContractsPublicService,

			tabs:      ContractsPublicService.contractTypeList,
			contracts: [] as ContractPublic[],
		};
	},

	computed: {
		/** id активного таба — из сегмента роута /list/contracts-public/{contractType} */
		activeId(): string {
			return this.$route.params.contractType as string;
		},

		today(): Date {
			return this.$core.utils.date.toDayStart(new Date());
		},
	},

	watch: {
		activeId() {
			this.loadContracts();
		},
	},

	created() {
		this.loadContracts();
	},

	methods: {
		/** Загрузить список оферт активного таба (таб → type) */
		async loadContracts(): Promise<void> {
			this.contracts = await ContractsPublicService.getList({ type: this.activeId } as ContractPublic['type']);
		},

		/**
		 * Открыть просмотр или редактирование контракта (черновик → редактор)
		 */
		onContractWatch(contract: ContractPublic): void {
			if (contract.isDraft) {
				this.$router.push(`${ContractsPublicService.baseUrl}/${contract.type.id}/edit`);
				return;
			}
			this.$router.push(`${ContractsPublicService.baseUrl}/${contract.type.id}/${contract.version}`);
		},
	},
});
</script>
